import { useState, useEffect } from "react";
import { message, Upload } from "antd";
import { useContext } from "react";
import { ProfileContext } from "Common/hooks/context/ProfileContext";
import {
  fetchManagerProfile,
  updateManagerProfile,
} from "PlatForms/OrgLMS/Services/LearnerService/LearnerProfileService";

const useLearnerProfile = (form) => {
  const [profileData, setProfileData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [imageUrl, setImageUrl] = useState("");
  const [fileList, setFileList] = useState([]);
  const token = localStorage.getItem("token");
  const { markProfileComplete, fetchProfileStatus} = useContext(ProfileContext);

  const getProfile = async () => {
    try {
      setLoading(true);
      const response = await fetchManagerProfile(token);
      setProfileData(response.data);

      form.setFieldsValue({
        firstName: response.data.firstName,
        lastName: response.data.lastName,
        phoneNo: response.data.phoneNo,
        businessGroupId: response.data.businessGroupId,
        country: response.data.country,
        state: response.data.state,
        city: response.data.city,
      });

      if (response.data.profileImage) {
        setImageUrl(`${process.env.REACT_APP_URL}${response.data.profileImage}`);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const updateProfile = async (values, navigate) => {
    try {
      setUpdating(true);
      const response = await updateManagerProfile(token, values, fileList);

      setProfileData(response.data);
         message.success("Profile updated successfully!");
      markProfileComplete();
      setTimeout(() => {
  fetchProfileStatus();
}, 1000);
        navigate("/mentor-dashboard");


      if (response.data.profileImage) {
        setImageUrl(`${process.env.REACT_APP_URL}${response.data.profileImage}`);
      }

      setFileList([]);
      navigate("/manager-dashboard");
    } catch (error) {
      console.error(error);
    } finally {
      setUpdating(false);
    }
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
    const isLt2M = file.size / 1024 / 1024 < 2;

    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
      return Upload.LIST_IGNORE;
    }

    if (!isLt2M) {
      message.error("Image must be smaller than 2MB!");
      return Upload.LIST_IGNORE;
    }

    return true;
  };

  const handleImageChange = (info) => {
    let newFileList = [...info.fileList].slice(-1);

    newFileList = newFileList.map((file) => {
      if (file.response) {
        file.url = file.response.url;
      }
      return file;
    });

    setFileList(newFileList);

    if (newFileList.length > 0 && newFileList[0].originFileObj) {
      const reader = new FileReader();
      reader.onload = (e) => setImageUrl(e.target.result);
      reader.readAsDataURL(newFileList[0].originFileObj);
    }
  };

  useEffect(() => {
    getProfile();
  }, []);

  return {
    profileData,
    loading,
    updating,
    imageUrl,
    fileList,
    beforeUpload,
    handleImageChange,
    updateProfile,
    setFileList,
  };
};

export default useLearnerProfile;
